"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lernsets = (sdk) => {
    const { sdkConfig: { url }, defaultVersion } = sdk;
    const httpClient = sdk.httpClient;
    return {
        addLernset: async (userId, payload) => {
            const endpoint = `${url}/${defaultVersion}/users/${userId}/lernsets`;
            const result = await httpClient.post(endpoint, { payload });
            return result.data;
        },
        getLernsetsByOwner: async (userId) => {
            const endpoint = `${url}/${defaultVersion}/users/${userId}/lernsets`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        getPublicLernset: async (accessToken) => {
            const endpoint = `${url}/${defaultVersion}/lernsets/public/${accessToken}`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        addPagesToLernset: async (userId, lernsetId, payload) => {
            const endpoint = `${url}/${defaultVersion}/users/${userId}/lernsets/${lernsetId}/pages`;
            const result = await httpClient.put(endpoint, { payload });
            return result.data;
        },
        getPartsImages: async (lernsetId, partIndices, imageMaxSideLength, accessToken) => {
            const endpoint = `${url}/${defaultVersion}/lernsets/${lernsetId}/parts/images`;
            const result = await httpClient.post(endpoint, {
                payload: { partIndices, imageMaxSideLength },
                query: { accessToken },
                auth: !accessToken
            });
            return result.data;
        },
        deleteLernset: async (lernsetId) => {
            const endpoint = `${url}/${defaultVersion}/lernsets/${lernsetId}`;
            const result = await httpClient.delete(endpoint);
            return result.data;
        },
        duplicateLernsetPart: async (lernsetId, partId) => {
            const endpoint = `${url}/${defaultVersion}/lernsets/${lernsetId}/parts/${partId}/duplicate`;
            const result = await httpClient.post(endpoint);
            return result.data;
        },
        updateLernset: async (lernsetId, payload) => {
            const endpoint = `${url}/${defaultVersion}/lernsets/${lernsetId}/update`;
            const result = await httpClient.post(endpoint, { payload });
            return result.data;
        },
        getLernsetPartToken: async (lernsetId, partId) => {
            const endpoint = `${url}/${defaultVersion}/lernsets/${lernsetId}/parts/${partId}/documentToken`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        getLernsetPartsTokens: async (lernsetId, accessToken) => {
            const endpoint = `${url}/${defaultVersion}/lernsets/${lernsetId}/partsTokens`;
            const result = await httpClient.get(endpoint, {
                query: { accessToken },
                auth: !accessToken
            });
            return result.data;
        },
        createPublicLink: async (lernsetId) => {
            const endpoint = `${url}/${defaultVersion}/lernsets/${lernsetId}/publicLink`;
            const result = await httpClient.post(endpoint);
            return result.data;
        },
        trackLernset: async (lernsetId, payload, accessToken = '') => {
            const endpoint = `${url}/${defaultVersion}/lernsets/${lernsetId}/track`;
            const result = await httpClient.post(endpoint, {
                payload,
                query: { accessToken },
                auth: !accessToken
            });
            return result.data;
        },
        addRichtextPart: async (lernsetId, payload) => {
            const endpoint = `${url}/${defaultVersion}/lernsets/${lernsetId}/addRichText`;
            const result = await httpClient.post(endpoint, { payload });
            return result.data;
        },
        getLernsetById: async (lernsetId) => {
            const endpoint = `${url}/${defaultVersion}/lernsets/${lernsetId}`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        getImageBase64: async (imageUrl) => {
            const endpoint = `${url}/${defaultVersion}/lernsets/imageBase64`;
            const result = await httpClient.post(endpoint, {
                payload: {
                    imageUrl
                }
            });
            return result.data;
        },
        uploadImage: async (lernsetId, formData) => {
            const endpoint = `${url}/${defaultVersion}/lernsets/${lernsetId}/uploadImage`;
            const result = await httpClient.post(endpoint, {
                payload: formData,
            });
            return result.data;
        }
    };
};
exports.default = lernsets;
